import DropdownFilter from '@/components/modal-select/filters/DropdownFilter.js';

/**
 * Filter for group categories.
 * Extends DropdownFilter to provide category-specific filtering functionality.
 * All dropdown behavior is inherited from DropdownFilter:
 * - type: 'dropdown'
 * - options: []
 * - autoApply: true
 * - handler for filter events
 * - addOption/addOptions methods
 * - isActiveChoice method
 * - clearFilter method
 * - is_applied getter
 */
export default class GroupCategoryFilter extends DropdownFilter {
    /**
     * This method is intentionally empty as the filtering is handled
     * by the queryBuilder in the inherited handler.
     * Required by the Filter interface but not used in this implementation.
     */
    applyToModel(query, value, field) {}
}
